import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SHARE CREATION (ESOP SHARE DETAIL) VERIFICATION
// Legacy: /AccountsApproval/VerifyShareCreation (+ VerifyShareCreationGrid / VerifyShareCreationView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — employee share grants pending at this role's level.
export const getVerifyShareCreationGrid = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/VerifyShareCreationGrid`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail: scheme, employee, vesting, grant, exercise option, compliance document, MOID.
export const getVerifyShareCreationView = async (refNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/VerifyShareCreationView`, { params: { Refno: refNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApproveShareCreation — success literal "Submitted"; action in Status).
export const approveShareCreation = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveShareCreation`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
